/** @format */

import { createContext } from 'react';

export const EventContext = createContext({
  events: [],
  eventsImportant: [],
  event: {},
  fields: [],
  forms: [],
  form: {},
  formBuilderFieldsData: [],
  provinces: [],
  province: {},
  authUser: {},
  authRoles: [],
  accessProvinceListuser: {},
  supervisor: {},
  users: [],
  user: {},
  organizers: [],
  organizer: {},
  categories: [],
  category: {},
  teams: [],
  team: {},
  exports: [],
  roles: [],
  transactions: [],
  sportFields: [],
  sportField: [],
  idCards: [],
  idCard: {},
  idCardFields: {
    fields: [],
    width: '',
    height: '',
    font_size: 12,
    background_image: '',
    background_color: '',
    title: '',
    signature: {},
    qrCode: {},
    event_id: {},
  },
  fandoms: [],
  fandom: {},
  cities: [],
  city: {},
  transactionsInfo: {},
  accessProvinceList: [],
  gatwayes: [],
  setting: {},
});
